import React, { ReactElement, ReactNode } from 'react'
import { Flex, Text, ThemeUIStyleObject } from 'theme-ui'
import getEnglishStrings from 'utils/getEnglishStrings'

const maxWidthAndHeight = ['18.9rem', '22.8rem']

export default function Hero({
  data,
  sxx,
  children,
}: {
  data: Queries.DirectusData_component_hero
  sxx?: ThemeUIStyleObject
  children?: ReactNode
}): ReactElement {
  const strings = getEnglishStrings(data?.strings)
  return (
    <Flex
      sx={{
        gap: ['1.6rem', '4.8rem'],
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        flexDirection: ['column', 'row'],
        ...sxx,
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          gap: '1.6rem',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Text
          as="h1"
          variant="h1Big"
          sx={{
            textAlign: 'center',
          }}
        >
          {strings?.title}
        </Text>
        {children}
      </Flex>
      {data.image && (
        <img
          src={`${process.env.GATSBY_WEBSITE_BASE_URL}/assets/${data.image?.filename_disk}`}
          alt=""
          sx={{ maxWidth: maxWidthAndHeight, maxHeight: maxWidthAndHeight }}
        />
      )}
    </Flex>
  )
}
